import {BASE_PATH} from "../wpconfig";

let gInit = false;

export function menuHook(object, name) {
	if(name) {
		let t = document.title.split('–');
		document.title = name + ' –' + t[1]
	}

	$('li.menu-item').removeClass('current-menu-item');
	if (window.location.href.includes('journal')) {
		$("a[href*='journal']").parent('li.menu-item').addClass('current-menu-item');
	} else if (window.location.href.includes('resource')) {
		$("a[href*='resource']").parent('li.menu-item').addClass('current-menu-item');
	} else if (window.location.href.includes('/scholars') || window.location.href.includes('/scholar/?record_id')) {
		$("a[href*='/scholars']").parent('li.menu-item').addClass('current-menu-item');
	} else if (window.location.href.includes('search')) {
		$("a[href*='search']").parent('li.menu-item').addClass('current-menu-item');
	} else if (window.location.href.includes('department')) {
		$("a[href*='department']").parent('li.menu-item').addClass('current-menu-item');
	} else if (window.location.href.includes('mypage')) {
		$("a[href*='mypage']").parent('li.menu-item').addClass('current-menu-item');
	}

	if (!gInit) {
		// window.console.log(gInit + '보자 보자')
		(function ($) {
			$(document).ready(function () {
				$(document).on('click', '#gnb li.menu-item a', function (e) {
					e.preventDefault();

					$('#ks').val('');

					if ($(this).attr('href').indexOf("/search/") != -1) {
						object.props.history.push(BASE_PATH + "search/");
						$('input[name=combineSort][value=search]').trigger('click');
					} else if ($(this).attr('href').indexOf("/journals/") != -1) {
						object.props.history.push(BASE_PATH + "journals/");
						if(typeof object.facetReset === "function"){
							object.facetReset()
							object.getList()
						}
						$('input[name=combineSort][value=journals]').trigger('click');
					} else if ($(this).attr('href').indexOf("/resources/") != -1) {
						object.props.history.push(BASE_PATH + "resources/");
						if(typeof object.facetReset === "function"){
							object.facetReset()
							object.getList()
						}
						$('input[name=combineSort][value=resources]').trigger('click');
					} else if ($(this).attr('href').indexOf("/scholars/") != -1) {
						object.props.history.push(BASE_PATH + "scholars/");
						if(typeof object.facetReset === "function"){
							object.facetReset()
							object.getList()
						}
						$('input[name=combineSort][value=scholars]').trigger('click');
					} else if ($(this).attr('href').indexOf("/departments/") != -1) {
						object.props.history.push(BASE_PATH + "departments/");
						// $('input[name=combineSort][value=departments]').trigger('click');
					} else if ($(this).attr('href').indexOf("/mypage/") != -1) {
						object.props.history.push(BASE_PATH + "mypage/");
						// $('input[name=combineSort][value=mypage]').trigger('click');
					}
				});
				gInit = true;
			});
		}(jQuery));
	}
}

